import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=a5b66a06&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=a5b66a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b66a06",
  null
  
)

export default component.exports